import { render, staticRenderFns } from "./essay_rubric_select.vue?vue&type=template&id=6dbf9665&scoped=true&"
import script from "./essay_rubric_select.vue?vue&type=script&lang=js&"
export * from "./essay_rubric_select.vue?vue&type=script&lang=js&"
import style0 from "./essay_rubric_select.vue?vue&type=style&index=0&id=6dbf9665&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbf9665",
  null
  
)

export default component.exports